import { Flex, Icon, Text } from '@chakra-ui/react';

import NavLinkItems from 'app/constants/navigation';

interface BackToCompaniesProps {
  onNavigate: (path: string) => void;
}

/**
 * "All companies" link rendered above the company name in the sidebar header
 * slot when managing a single company. Styled for the dark sidebar.
 */
function BackToCompanies({ onNavigate }: BackToCompaniesProps) {
  return (
    <Flex
      as="button"
      data-testid="sidebar-back-to-companies"
      align="center"
      gap="10px"
      w="100%"
      p={{ base: '15px 30px', sm: '15px 56px', lg: '15px 20px' }}
      color="brand.whiteAlpha75"
      _hover={{ color: 'brand.white' }}
      onClick={() => onNavigate(NavLinkItems.backToCompanies.path)}
    >
      <Icon as={NavLinkItems.backToCompanies.icon} boxSize="20px" />
      <Text textStyle="smallMedium">{NavLinkItems.backToCompanies.name}</Text>
    </Flex>
  );
}

export default BackToCompanies;
